export enum PriceAdherenceGroupBy {
  MarginMatrix = 'MarginMatrix',
  Location = 'Location',
  Advisor = 'Advisor'
}
